import { render, staticRenderFns } from "./CBM.vue?vue&type=template&id=755be51c"
import script from "./CBM.vue?vue&type=script&lang=js"
export * from "./CBM.vue?vue&type=script&lang=js"
import style0 from "./CBM.vue?vue&type=style&index=0&id=755be51c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports